/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgCrossCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.0402 9.9598L10 6'
      stroke='currentColor'
      strokeWidth={1.76}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.0402 6.00016L10 9.95996'
      stroke='currentColor'
      strokeWidth={1.76}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx={8} cy={8} r={7.12} stroke='currentColor' strokeWidth={1.76} />
  </svg>
)
export default SvgCrossCircle
